@if (docid() > 0 && formid() > 0) {
    <a class="a_without_href" (click)="openDocument()">
        <ng-content></ng-content>
    </a>
} @else {
    <ng-content></ng-content>
}
<sec-document-viewer></sec-document-viewer>